<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col lg:w-4/4 w-full relative">
        <vx-card title="">
          <div class="demo-alignment">
            <div class="vx-row" style="width: 100%">
              <div class="vx-col lg:w-3/12">
                <v-select
                  :options="[
                    'N11',
                    'Gittigidiyor',
                    'Ciceksepeti',
                    'PttAvm',
                    'Hepsiburada',
                    'Trendyol',
                  ]"
                  v-model="selectedPazaryeri"
                  @input="KategoriCek"
                  label="name"
                  :taggable="true"
                >
                </v-select>
              </div>
              <div class="vx-col lg:w-3/12">
                <v-select
                  v-model="selected1"
                  :options="list"
                  label="name"
                ></v-select>
              </div>

              <div class="vx-col lg:w-2/12">
                <vs-input
                  class="inputx"
                  style="width: auto"
                  :ref="satisOran"
                  v-model="satisOran"
                />
              </div>
              <div class="vx-col lg:w-2/12">
                <vs-input
                  class="inputx"
                  style="width: auto"
                  :ref="ekTutar"
                  v-model="ekTutar"
                />
              </div>
              <div class="vx-col lg:w-2/12">
                <vs-button
                  @click="KategoriGuncelle()"
                  size="small"
                  color="success"
                  type="filled"
                >
                  <svg
                    width="20px"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-refresh-ccw"
                  >
                    <polyline points="1 4 1 10 7 10"></polyline>
                    <polyline points="23 20 23 14 17 14"></polyline>
                    <path
                      d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
                    ></path>
                  </svg>
                </vs-button>
              </div>
            </div>
          </div>
        </vx-card>

        <vx-card title="" style="margin-top: 10px">
          <vs-table :data="KategoriOranlariListesi">
            <template slot="thead">
              <vs-th sort-key="stokkodu">Pazaryeri</vs-th>
              <vs-th sort-key="stokkodu">Kategori</vs-th>
              <vs-th>Kar Oranı</vs-th>
              <vs-th>Kargo</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].program">
                  {{ data[indextr].program }}
                </vs-td>
                <vs-td :data="data[indextr].kategori1Ad">
                  {{ data[indextr].kategori1Ad }}
                </vs-td>
                <vs-td :data="data[indextr].fiyatOran">
                  {{ "%" + data[indextr].fiyatOran }}
                </vs-td>
                <vs-td :data="data[indextr].kargoEkTutar">
                  {{ data[indextr].kargoEkTutar }}
                </vs-td>
               
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import state from "../../store/state";
import Store from "../../store/store";

export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      options: [],
      optionsParti: [],
      pazaryeriTum: [],
      list: [],
      listSonFaturalar: [],
      listSiparis: [],
      KategoriOranlariListesi: [],
      progress: 0,
      activePrompt: false,
      pazaryeriVal: "",
      partiVal: "",
      satisOran: 0,
      ekTutar: 0,
      toplamParca: 0,
      selectedPazaryeri: { id: 0, name: "" },
      selectedPazaryeriKategori: { id: 0, label: "Pazaryeri Kategori" },
      selected: { id: 0, label: "Cari" },
      selectedDepo: "",
      iadeModel: { id: 0, label: "İade red" },
      selectedParti: { id: 0, label: "Parti Nolar" },
      popupActive: false,
      popupFatura: false,
      popupActiveSiparis: false,
      popupActiveCikti: false,
      barkod: "",
      barkodAdet: "",
      cariKod: "",
      siparisBulOrderNumber: "",
      genelSiparisNo: "",
      selected1: { id: 0, name: "Kategoriler" },
      genelKargoAdi: "",
      genelKargoNo: "",
      genelMusteri: "",
      hediyeMi: 0,
      genelToplam: 0,
      eklenenDeger: "",
      indext: 0,
      indext1: 0,
      urunResim: "",
      validated: 1,
      Bvalidated: 1,
      validatedF: 1,
      siparisToplamParca: 0,
      eklenenToplamParca: 0,
      askiDurumu: false,
      aski: 0,
      imageLink: "",
      ciktiListesi: [],
      jsonD: "",
      dr: "",
      popupActiveFaturaCikti: false,
      receiptId: 0,
      faturaNo: "",
      ilkOkuma: 0,
      recId: 0,
      total: 0,
      faturaAranan: "",
      faturaBulOrderNumber: "",
      im: 0,
      iadeOrderNumber: "",
      iadeLineItemId: "",
      dprogram: "",
      dpazaryeriKategori: "",
      dfiyatOran: "",
      dkargoEkTutar: "",
    };
  },
  methods: {
    Listele(pazaryeri) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        program: pazaryeri,
        token: Store.state.tokenId,
      };
      //alert("Listelendi")
      soap.createClient(url, function (err, client) {
        client.eslemeListesi(args, function (err, result) {
          if (result.eslemeListesiResult == "-1") {
            Store.dispatch("logout");
          }
          vm.veriler = JSON.parse(result.eslemeListesiResult);
          vm.KategoriOranlariListesi = vm.veriler;
          //console.log(vm.veriler);
        });
      });
    },
    KategoriCek() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { pazaryeri: vm.selectedPazaryeri };

      console.log(args);
      soap.createClient(url, function (err, client) {
        client.pazaryeriKategoriListe(args, function (err, result) {
          if (result.pazaryeriKategoriListeResult == "-1") {
            Store.dispatch("logout");
          }
          console.log(
            "result.pazaryeriKategoriListeResult:" +
              result.pazaryeriKategoriListeResult
          );
          vm.veriler = JSON.parse(result.pazaryeriKategoriListeResult);

          vm.list = vm.veriler;

          console.log("vm.list:" + vm.list);
        });
      });
      this.Listele(vm.selectedPazaryeri);
    },
    KategoriGuncelle() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        program: vm.selectedPazaryeri,
        pazaryeriId: vm.selected1.id,
        oran: vm.satisOran,
        kargoTutar: vm.ekTutar,
        token: Store.state.tokenId,
      };

      console.log(args);
      soap.createClient(url, function (err, client) {
        client.pazaryeriOranEkle(args, function (err, result) {
          if (result.KategoriOranlariListesiResult == "-1") {
            Store.dispatch("logout");
          }

          //vm.veriler = JSON.parse(result.KategoriOranlariListesiResult);
          //vm.KategoriOranlariListesi = vm.veriler;
          //console.log(vm.KategoriOranlariListesi )
        });
      });
      this.Listele(vm.selectedPazaryeri);
    },
    OranGuncelle(id) {
      //alert(id)
      this.dprogram = "";
      this.dpazaryeriKategori = "";
      this.dfiyatOran = "";
      this.dkargoEkTutar = "";

      const args = { token: Store.state.tokenId, kod: kod, kodTanim: "" };

      soap.createClient(url, function (err, client) {
        client.stokListesi(args, function (err, result) {
          if (result.stokListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.verilerDetay = JSON.parse(result.stokListesiResult);
          console.log(vm.verilerDetay);
          vm.dStokAdi = vm.verilerDetay[0].StokAdi;
          vm.dStokKodu = vm.verilerDetay[0].stokKodu;
          vm.dBarkod = vm.verilerDetay[0].Barkod;
        });
      });
    },
  },
  beforeMount() {
    //this.KategoriCek();
    //this.Listele();
  },
};
</script>

<style lang="scss" scoped>
.v-select .vs__selected {
  font-size: 10px;
}
.mb-base {
  margin-bottom: 0.75rem !important;
}
.list-view-item {
  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
